import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import DashboardLayout from "./layouts/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Contacts from "./pages/Contacts";
import CreateContact from "./pages/CreateContact";
import ContactCategories from "./pages/ContactCategories";
import Settings from "./pages/Settings";
import SendEmail from "./pages/SendEmail/SendEmail";
import EmailHistory from "./pages/EmailHistory";
import TemplatesList from "./pages/TemplatesList";
import CreateTemplate from "./pages/CreateTemplate";
import EditTemplate from "./pages/EditTemplate";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import MeetingsPage from "./pages/Meetings/MeetingsPage";
import MeetingSettings from "./pages/Meetings/MeetingSettings";
import MeetingTypes from "./pages/Meetings/MeetingTypes";
import CalendarPage from "./pages/Meetings/CalendarPage";
import BookingPage from "./pages/BookingPage/BookingPage";

import { useAuth } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";

function PrivateRoute({ children }) {
  const { user, initializing } = useAuth();

  if (initializing) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return user ? children : <Navigate to="/" replace />;
}

export default function App() {
  const { user, initializing } = useAuth();

  return (
    <BrowserRouter>
      {/* Global Toaster */}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#fff",
            color: "#333",
            border: "1px solid #ddd",
            zIndex: 9999,
          },
        }}
      />

      <Routes>
        {/* LOGIN ROUTE */}
        <Route
          path="/"
          element={
            initializing ? (
              <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="text-center">
                  <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
                  <p className="mt-2 text-gray-600">Loading...</p>
                </div>
              </div>
            ) : user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login />
            )
          }
        />

        {/* FORGOT PASSWORD */}
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* RESET PASSWORD */}
        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />

        {/* PROTECTED DASHBOARD ROUTES */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="contacts/list" element={<Contacts />} />
          <Route path="contacts/add" element={<CreateContact />} />
          <Route path="contacts/categories" element={<ContactCategories />} />
          <Route path="settings" element={<Settings />} />

          {/* Email */}
          <Route path="email/send" element={<SendEmail />} />
          <Route path="email/history" element={<EmailHistory />} />

          {/* Templates */}
          <Route path="templates/list" element={<TemplatesList />} />
          <Route path="templates/create" element={<CreateTemplate />} />
          <Route path="templates/edit/:id" element={<EditTemplate />} />

          {/* Meetings */}
          <Route path="meetings" element={<MeetingsPage />} />
          <Route path="meetings/calendar" element={<CalendarPage />} />
          <Route path="meetings/settings" element={<MeetingSettings />} />
          <Route path="meetings/types" element={<MeetingTypes />} />
        </Route>

        {/* PUBLIC BOOKING PAGE — no auth required */}
        <Route path="/book/:slug" element={<BookingPage />} />

        {/* CATCH-ALL */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
